import React from 'react'
import styled, { css } from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
`

const Label = styled.label`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.muted};
`

const inputSizes = {
  sm: css`height: 40px; font-size: 14px;`,
  md: css`height: 40px; font-size: 15px;`,
  lg: css`height: 48px; font-size: 16px;`
}

const Field = styled.input`
  width: 100%;
  flex: 1;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radii.md};
  padding: 8px 12px;
  background: white;
  color: ${({ theme }) => theme.colors.text};
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  ${(p) => p.as !== 'textarea' && inputSizes[p.$size || 'md']};
  &:focus { border-color: ${({ theme }) => theme.colors.primary}; box-shadow: 0 0 0 3px rgba(41,98,255,0.2); }
  ${(p) => p.$error && css`border-color: ${p.theme.colors.danger}; box-shadow: 0 0 0 3px rgba(211,47,47,0.2);`}
  ${(p) => p.disabled && css`opacity: 0.6; pointer-events: none;`}
  ${(p) => p.as === 'textarea' && css`
    min-height: 80px;
    height: auto;
    resize: vertical;
    font-family: inherit;
    line-height: 1.5;
  `}

  &[type="date"], &[type="time"], &[type="datetime-local"] {
    appearance: none;
    min-width: 150px;
    color: ${({ theme }) => theme.colors.text};
    font-family: inherit;
    accent-color: ${({ theme }) => theme.colors.primary};
    
    &::-webkit-calendar-picker-indicator {
      cursor: pointer;
      opacity: 0.5;
      transition: opacity 0.2s;
      padding: 4px;
      
      &:hover {
        opacity: 1;
      }
    }
  }
`

const Helper = styled.div`
  font-size: 12px;
  color: ${(p) => (p.$error ? p.theme.colors.danger : p.theme.colors.muted)};
`

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`

export const TextInput = React.forwardRef(({ label, value, onChange, placeholder, size = 'md', error, helperText, disabled, type = 'text', name, startAction, endAction, multiline, rows, ...props }, ref) => {
  return (
    <Wrapper>
      {label && <Label htmlFor={name}>{label}</Label>}
      <InputContainer>
        {startAction}
        <Field 
          ref={ref}
          as={multiline ? 'textarea' : 'input'}
          rows={rows}
          id={name} 
          name={name} 
          value={value} 
          onChange={onChange} 
          placeholder={placeholder} 
          $size={size} 
          $error={!!error} 
          disabled={disabled} 
          type={type} 
          {...props} 
        />
        {endAction}
      </InputContainer>
      {(helperText || error) && <Helper $error={!!error}>{error || helperText}</Helper>}
    </Wrapper>
  )
})
